(function (argument) {
	'use strict';

	angular.module("changdobels")
		.component("cdDatepicker", {
			templateUrl: ['TEMPLATE_URL', function templateUrl( TEMPLATE_URL ) {
				return TEMPLATE_URL + '/templates/datepicker.html';
			}],
			bindings: {
				label: '@cdLabel',
				maxDate: '<cdMaxDate',
				minDate: '<cdMinDate',
				name: '@cdName',
				onDateSelect: '&cdOnDateSelect',
				onRenderDay: '&cdOnRenderDay',
				required: '<cdRequired',
			},
			controller: DatePickerController
		});

	DatePickerController.$inject = [
		'$scope',
		'$element'
	];

	function DatePickerController($scope, $element) {
		var $ctrl = this;

		var input;

		$ctrl.$postLink = $postLink;
		$ctrl.$onDestroy = $onDestroy;
		$ctrl.showDatepicker = showDatepicker;
		$ctrl.onSelect = onSelect;

		$ctrl.value = '';
		$ctrl.formattedMinDate = '';
		$ctrl.formattedMaxDate = '';

		function $postLink() {
			input = $element.find( 'input' );

			$scope.$applyAsync(function () {
				input.datepicker({
					constrainInput: true,
					changeMonth: true,
					changeYear: true,
					shortYearCutoff: 1,
					showOtherMonths: false,
            		selectOtherMonths: false,
					dateFormat: 'yy-mm-dd',
					minDate: $ctrl.minDate,
					maxDate: $ctrl.maxDate || moment( $ctrl.minDate ).add( 1, 'Y' ).toDate(),
					beforeShowDay: function ( date ) {
						var dayOptions = [ true, "cd-datepicker__day", "" ];
						var newDayOptions = $ctrl.onRenderDay({date: date, dayOptions: dayOptions});
						return newDayOptions || dayOptions;
					},
					onSelect: function ( date ) {
						$scope.$evalAsync(function () {
							$ctrl.value = date;
							$ctrl.onSelect();
						});
					},
					yearRange: moment().format( 'YYYY' ) + ':' + moment().add( 2, 'Y' ).format( 'YYYY' )
				});

				$scope.$watch('$ctrl.minDate', function ( minDate ) {
					if ( minDate ) {
						input.datepicker( "option", "minDate", minDate );

						var momentMinDate = moment( minDate );
						$ctrl.formattedMinDate = momentMinDate.format( 'YYYY-MM-DD' );

						if ( $ctrl.value && momentMinDate > moment( $ctrl.value ) ) {
							$ctrl.value = $ctrl.formattedMinDate;
							$ctrl.onSelect();
						}
					}
				});

				$scope.$watch('$ctrl.maxDate', function ( maxDate ) {
					if ( maxDate ) {
						input.datepicker( "option", "maxDate", maxDate );

						var momentMaxDate = moment( maxDate );
						$ctrl.formattedMaxDate = momentMaxDate.format( 'YYYY-MM-DD' );

						if ( $ctrl.value && momentMaxDate < moment( $ctrl.value ) ) {
							$ctrl.value = $ctrl.formattedMaxDate;
							$ctrl.onSelect();
						}
					}
				});
			});
		}

		function $onDestroy() {
			input.datepicker( "destroy" );
		}

		function onSelect() {
			$ctrl.onDateSelect( { date: $ctrl.value } );
		}

		function showDatepicker() {
			input.datepicker( 'show' );
		}
	}
})();